import React from 'react';
import PropTypes from 'prop-types';
import hasHoc from 'util/hoc/has-hoc';
import OutcomeHeaderActionOptions from 'apps/journey/pages/my-journey2/outcomes/outcome-header-actions-options';
import Goal from 'apps/journey/pages/my-journey2/goals/goal';
import * as StyledAllGoals from 'apps/journey/pages/my-journey2/goals/styled-goal';

const Goals = ({
  outcome,
  outcomes,
  activeOutcomeId,
  setFlipped,
  isVisible,
  configuration,
}) => {
  const mapGoals = (goal) => {
    return (
      <Goal
        activeOutcomeId={activeOutcomeId}
        outcome={outcome}
        outcomes={outcomes}
        goal={goal}
        isVisible={isVisible}
      />
    );
  };

  return (
    <StyledAllGoals.StyledGoals color={outcome.color}>
      <StyledAllGoals.StyledCardHeader onClick={() => setFlipped(false)}>
        <h2> {outcome.name} </h2>
        <OutcomeHeaderActionOptions
          configuration={configuration}
          setFlipped={setFlipped}
          id={outcome.id}
          outcome={outcome}
          isVisible={isVisible}
          label="Flip to hide goals"
        />
      </StyledAllGoals.StyledCardHeader>
      <StyledAllGoals.StyledGoalCount>
        {' '}
        {outcome.goals.length || 0} Goals{' '}
      </StyledAllGoals.StyledGoalCount>
      <StyledAllGoals.StyledDescription>
        {' '}
        {outcome.description}{' '}
      </StyledAllGoals.StyledDescription>
      <StyledAllGoals.StyledGoalsList>
        {outcome.goals.map(mapGoals)}
      </StyledAllGoals.StyledGoalsList>
    </StyledAllGoals.StyledGoals>
  );
};

Goals.propTypes = {
  outcome: PropTypes.object,
  outcomes: PropTypes.array,
  activeOutcomeId: PropTypes.number,
  setFlipped: PropTypes.func,
  configuration: PropTypes.object,
  isVisible: PropTypes.bool,
};

Goals.hoc_list = ['withConfig'];

export default hasHoc(Goals);
